import React from "react";

// ----- Alert row -----------------------------------------------------
const SEVERITY_CONFIG = {
  red:    { bg: "#fdecec", border: "#f3b8b8", text: "#a23a3a", icon: "🔴" },
  yellow: { bg: "#fff8e7", border: "#f0d38b", text: "#8a5a00", icon: "🟡" },
  green:  { bg: "#e8f8e9", border: "#a8d8a8", text: "#1b6b1e", icon: "🟢" },
};

export default function AlertRow({ alert }) {
  const cfg = SEVERITY_CONFIG[alert.severity] || SEVERITY_CONFIG.yellow;
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "auto 1fr auto auto",
        gap: 10,
        alignItems: "center",
        padding: "10px 12px",
        background: cfg.bg,
        border: `1px solid ${cfg.border}`,
        borderRadius: 8,
        marginBottom: 6,
      }}
    >
      <span style={{ fontSize: "1.1rem" }} aria-hidden="true">{cfg.icon}</span>
      <div>
        <div style={{ fontWeight: 600, color: cfg.text }}>
          {alert.restaurant_name}
          <span className="muted" style={{ fontWeight: 400, marginLeft: 8, fontSize: "0.82rem" }}>
            #{alert.restaurant_id} · {alert.tier}
          </span>
        </div>
        <div style={{ fontSize: "0.88rem", color: "#3e4c59" }}>
          {alert.message}
        </div>
      </div>
      <span
        style={{
          fontSize: "0.7rem",
          textTransform: "uppercase",
          letterSpacing: 0.5,
          color: cfg.text,
          fontWeight: 700,
        }}
      >
        {alert.kind.replace(/_/g, " ")}
      </span>
      {/* Day 3 will turn this into a real drill-in link */}
      <span className="muted" style={{ fontSize: "0.75rem" }}>
        {alert.restaurant_email}
      </span>
    </div>
  );
}
